import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
    async getTrainingSystems(params) {
        try {
            const response = await axios.get(`uni/trainingSystems/getByOrganizationId`, {params})
            const { data } = response
            return data.data
        } catch (e) {
            handleCatch(e)
        }
        return null
    },
    async getCoursesByTrainingSystemId(params) {
        try {
            const response = await axios.get(`uni/courses/getByTrainingSystemId`, {params})
            const { data } = response
            return data.data
        } catch (e) {
            handleCatch(e)
        }
        return null
    },
    async getClassesByCourseId(params) {
        try {
            const response = await axios.get(`uni/classes/getByCourseId`, {params})
            const { data } = response
            return data.data
        } catch (e) {
            handleCatch(e)
        }
        return null
    },

    async getStudentsByClassId(params) {
        try {
            const response = await axios.get(`uni/students/getByClassId`, {params})
            const { data } = response
            return data.data
        } catch (e) {
            handleCatch(e)
        }
        return null
    },
}